import React from 'react';
import { Box, Paper, Typography } from '@mui/material';

/** A titled card on the personal dashboard. Callers pass already-translated text. */
export function DashSection({ title, subtitle, children }: { title: string; subtitle?: string; children: React.ReactNode }) {
    return (
        <Paper variant="outlined" sx={{ p: 2, minWidth: 0 }}>
            <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>{title}</Typography>
            {subtitle && <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 1 }}>{subtitle}</Typography>}
            <Box sx={{ mt: subtitle ? 0 : 1 }}>{children}</Box>
        </Paper>
    );
}

export function DashEmpty({ text }: { text: string }) {
    return <Typography variant="body2" color="text.secondary" sx={{ py: 2 }}>{text}</Typography>;
}
